import { auth } from "./auth/auth.module";
import { home } from "./home/home.module";
import { user } from "./user/user.module";
import { news } from "./news/news.module";
import { stages } from "./stages/stages.module";
import { invite } from "./invite/invite.module";
import { profile } from "./profile/profile.module";
import { newsTag } from "./news-tag/news-tag.module";
import { settings } from "./settings/settings.module";
import { timeline } from "./timeline/timeline.module";
import { resources } from "./resources/resources.module";
import { sendEmail } from "./send-email/send-email.module";
import { sendTextMessage } from "./send-sms/send-sms.module";
import { cmvrCenter } from "./cmvr-center/cmvr-center.module";
import { newsCategory } from "./news-category/news-category.module";
import { advertisements } from "./advertisements/advertisements.module";
import { commandCounsellors } from "./command-counsellors/command-counsellors.module";
import { commandCounsellorGroups } from "./command-counsellor-groups/command-counsellor-groups.module";
import { commandCounsellorGroupTM } from "./command-counsellor-group/command-counsellor-group.module";
import { statementOfBenefits } from "./statement-of-benefits/statement-of-benefits.module";
import { assignMemberToCommander } from "./assign-member-to-commander/assign-member-to-commander.module";
import branchOfService from "./branch-of-service/branch-of-service.module";
import rank from "./rank/rank.module";
import veteranStatus from "./veteran-status/veteran-status.module";
import { employerDirectory } from './employers-directory/employers-directory.module'

export const components = angular.module("components", [
  auth,
  home,
  user,
  news,
  stages,
  invite,
  profile,
  newsTag,
  settings,
  sendEmail,
  timeline,
  resources,
  newsCategory,
  advertisements,
  sendTextMessage,
  commandCounsellors,
  commandCounsellorGroups,
  commandCounsellorGroupTM,
  statementOfBenefits,
  assignMemberToCommander,
  cmvrCenter,
  branchOfService,
  rank,
  veteranStatus,
  employerDirectory
]).name;



// WEBPACK FOOTER //
// ./src/app/components/components.module.js